// ─────────────────────────────────────────────────────────────
// banKey.js
// Deterministic document IDs for the `blockedUsers` collection.
//
// Those documents hold an IP address or a browser fingerprint plus a name, so
// the collection is not listable by unauthenticated visitors (see
// firestore.rules). Keying each document by a hash of the thing being banned
// lets a visitor check whether THEY are banned with a single doc-ID get,
// without being able to enumerate anyone else's ban.
//
// kind: 'ip' (RSVP bans) | 'fp' (comment-thread bans)
// ─────────────────────────────────────────────────────────────

import { hashPhone as sha256Short } from './phoneHash';

export const banKey = async (kind, value) => `${kind}_${await sha256Short(String(value))}`;
